import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IApplicationConfiguration, defaultValue } from 'app/shared/model/application-configuration.model';

export const ACTION_TYPES = {
  FETCH_APPLICATIONCONFIGURATION_LIST: 'applicationConfiguration/FETCH_APPLICATIONCONFIGURATION_LIST',
  FETCH_APPLICATIONCONFIGURATION: 'applicationConfiguration/FETCH_APPLICATIONCONFIGURATION',
  CREATE_APPLICATIONCONFIGURATION: 'applicationConfiguration/CREATE_APPLICATIONCONFIGURATION',
  UPDATE_APPLICATIONCONFIGURATION: 'applicationConfiguration/UPDATE_APPLICATIONCONFIGURATION',
  DELETE_APPLICATIONCONFIGURATION: 'applicationConfiguration/DELETE_APPLICATIONCONFIGURATION',
  RESET: 'applicationConfiguration/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IApplicationConfiguration>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type ApplicationConfigurationState = Readonly<typeof initialState>;

// Reducer

export default (state: ApplicationConfigurationState = initialState, action): ApplicationConfigurationState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION_LIST):
    case REQUEST(ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_APPLICATIONCONFIGURATION):
    case REQUEST(ACTION_TYPES.UPDATE_APPLICATIONCONFIGURATION):
    case REQUEST(ACTION_TYPES.DELETE_APPLICATIONCONFIGURATION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION_LIST):
    case FAILURE(ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION):
    case FAILURE(ACTION_TYPES.CREATE_APPLICATIONCONFIGURATION):
    case FAILURE(ACTION_TYPES.UPDATE_APPLICATIONCONFIGURATION):
    case FAILURE(ACTION_TYPES.DELETE_APPLICATIONCONFIGURATION):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_APPLICATIONCONFIGURATION):
    case SUCCESS(ACTION_TYPES.UPDATE_APPLICATIONCONFIGURATION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_APPLICATIONCONFIGURATION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/application-configurations';

// Actions

export const getEntities: ICrudGetAllAction<IApplicationConfiguration> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION_LIST,
  payload: axios.get<IApplicationConfiguration>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IApplicationConfiguration> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_APPLICATIONCONFIGURATION,
    payload: axios.get<IApplicationConfiguration>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IApplicationConfiguration> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_APPLICATIONCONFIGURATION,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IApplicationConfiguration> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_APPLICATIONCONFIGURATION,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IApplicationConfiguration> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_APPLICATIONCONFIGURATION,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
